import { render, staticRenderFns } from "./FormUpload2.vue?vue&type=template&id=3872f4f4"
import script from "./FormUpload2.vue?vue&type=script&lang=js"
export * from "./FormUpload2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports